<template>
  <b-button :href="content.url" target="_blank">{{ content.label }}</b-button>
</template>

<script>
  export default {
    name: 'CtaButton',
    props: {
      content:{
        type: Object,
        required: true
      }
    }
  }
</script>
